<template>
  <div class="search">
    <el-form class="searchform" :class="{'search-hidden':search_hidden}" :style="{'height':search_height}" ref="form" :model="form" label-width="80px" label-position="left">
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">會員編號</label>
            <el-input v-model="form.customer_num" clearable placeholder="" ></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">會員名稱</label>
            <el-input v-model="form.name" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">證件號碼/BR.</label>
            <el-input v-model="form.card" clearable></el-input>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">電話號碼</label>
            <el-input v-model="form.phone" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">會員狀態</label>
            <el-select v-model="form.status" placeholder="全部" clearable>
              <el-option label="全部" value="-1"></el-option>
              <el-option label="Active 有效" value="0"></el-option>
              <el-option label="Suspended 暫停交易" value="1"></el-option>
              <el-option label="Terminated 終止業務關係" value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">會員類別</label>
            <el-select v-model="form.type" placeholder="全部" clearable>
              <el-option label="全部" value="-1"></el-option>
              <el-option label="個人" value="0"></el-option>
              <el-option label="企業" value="1"></el-option>
              <el-option label="行家" value="2"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">添加時間</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.starttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.endtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">舊會員編號</label>
            <el-input v-model="form.old_customer_num" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">B.R.有效期</label>
            <div class="mm-row">
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.brstarttime" style="width: 100%;"></el-date-picker>
              </div>
              <div class="mmline">-</div>
              <div class="mm-col">
                <el-date-picker type="date" placeholder="選擇日期" v-model="form.brendtime" style="width: 100%;"></el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">備註</label>
            <el-input v-model="form.remarks" clearable></el-input>
          </div>
        </div>
      </div>
      <div class="mm-row">
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序字段</label>
            <el-select v-model="form.sortname" placeholder="全部">
              <el-option label="添加日期" value="addtime"></el-option>
              <el-option label="會員編號" value="customer_num"></el-option>
              <el-option label="舊會員編號" value="old_customer_num"></el-option>
              <el-option label="B.R.有效期" value="company_card_date"></el-option>
              <el-option label="姓名/公司名稱" value="name"></el-option>
              <el-option label="英文名稱" value="ename"></el-option>
              <el-option label="電話號碼" value="phone"></el-option>
              <el-option label="身份證" value="card"></el-option>
              <el-option label="B.R.證件號碼" value="company_card"></el-option>
              <el-option label="風險評估" value="risk_level"></el-option>
              <el-option label="狀態" value="status"></el-option>
              <el-option label="備註" value="remarks"></el-option>
              <el-option label="ID" value="id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="mm-col">
          <div class="mm-item">
            <label class="mm-label">排序方式</label>
            <div class="mm-row">
              <div class="flex-start">
                <el-radio v-model="form.orderby" label="DESC">由高到低</el-radio>
                <el-radio v-model="form.orderby" label="ASC">由低到高</el-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mm-submitbox">
        <div>
          <el-button type="primary" plain @click="submit">清空</el-button>
          <el-button type="warning" plain @click="submit">刷新</el-button>
        </div>
      </div>
    </el-form>
    <div @click="changesearchbox" class="rowline">
      <div>
        <i class="mm-nav-arrow el-icon-arrow-down" style="font-size: 12px; margin-right: 5px;"></i><span>{{search_hidden_text}}</span>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "Search",
  props: ['form'],
  data () {
    return {
      search_height: 0,
      search_hidden: true,
      search_hidden_text: '檢索展開',
    }
  },
  methods: {
    submit () {
      this.form.customer_num = ''; 
      this.form.old_customer_num = ''; 
      this.form.starttime = ''; 
      this.form.endtime = ''; 
      this.form.brstarttime = ''; 
      this.form.brendtime = ''; 
      this.form.type = '-1'; 
      this.form.status= '-1'; 
      this.form.phone= ''; 
      this.form.card = ''; 
      this.remarks = '';
    this.form.sortname = "addtime";
      this.form.orderby = "DESC";
    },
    changesearchbox () {
      let search_height = this.$refs.form.$el.scrollHeight + 'px';
      if (this.search_hidden) {
        this.search_hidden = false;
        this.search_hidden_text = '檢索隱藏';
        this.search_height = search_height;
        console.log();
      } else {
        this.search_hidden = true;
        this.search_hidden_text = '檢索展開'
        this.search_height = 0;
      }
    }
  }

}
</script>

<style scoped>
.search {
  margin-top: 20px;
}
.searchform {
  transition: height ease 0.3s;
  overflow: hidden;
}

.rowline {
  border-bottom: 1px solid #66b1ff;
  display: flex;
  justify-content: center;
  padding-bottom: 5px;
  color: #409eff;
  cursor: pointer;
}
.search-hidden {
  height: 0;
  overflow: hidden;
}
@media screen and (max-width: 1024px) {
	  .mm-submitbox{ display: flex; justify-content:flex-end; }
	  .mm-row{ display: flex; flex-wrap: wrap; margin-bottom: 0; }
	  .mm-col{ flex: 1 100%;padding: 10px 0;}
	  .mm-label{ flex: 0 0 60px; padding-left: 0;}
	}
</style>
